import { render, staticRenderFns } from "./oldCustomerLogin.vue?vue&type=template&id=4a42fd56&"
import script from "./oldCustomerLogin.vue?vue&type=script&lang=js&"
export * from "./oldCustomerLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports